import metadataMappingServiceImpl from '../metadata-mapping-service';
import type { MetadataMappingService } from './contracts';

export type { MetadataMappingService } from './contracts';
export { pluralize } from '../pluralize';
export { openPopup } from '../pop-up-util';
export { PromiseQueue } from '../promise-queue';
export {
  guessDeviceLabel,
  isIosDevice,
  isPushSupported,
  isSafariOnMacNeedingInstall,
  isStandalone,
  urlBase64ToUint8Array,
} from '../push-support';
export const metadataMappingService: MetadataMappingService = metadataMappingServiceImpl;
